import React from 'react';
import css from './MainCard.module.css';
import { arrowRightSvg } from '../../utils';

const MainCard = ({ blog, setFocusedBlog }) => {
  if (!blog) return null;

  return (
    <div className={css.wrapper}>
      <div
        className={css.sectionLeft}
        style={{ backgroundImage: `url(${blog.preview.image})` }}
      ></div>
      <div className={css.sectionRight}>
        <p className={css.date}>
          Jun 25, 2025 – <span className={css.red}>5 min read</span>
        </p>
        <p className={css.title}>{blog.preview.title}</p>
        <p className={css.description}>{blog.preview.text}</p>
        <p className={css.readMore} onClick={setFocusedBlog}>
          Read More {arrowRightSvg}
        </p>
      </div>
    </div>
  );
};

export default MainCard;
